<template>
  <div v-if="$store.state.menu.Pages">
    <v-container fill-height fluid grid-list-xl>
      <Loader :loading="loading" />
      <v-layout justify-center wrap>
        <v-flex md12>
          <material-card color="green" title="Список страниц" text="DTE">
            <v-btn color="primary" class="mr-2" @click="getPages(false)" text>
              Обновить
            </v-btn>

            <v-btn
              color="success"
              class="mr-2"
              @click="PageAddModal = true"
              text
            >
              Добавить
            </v-btn>

            <div class="mt-2">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Поиск..."
                class="sticky search"
                :loading="loadingSearch"
                single-line
                hide-details
                clearable="true"
              ></v-text-field>
            </div>

            <v-data-table :headers="headers" :items="PagesList" hide-actions>
              <template slot="headerCell" slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>

              <template slot="items" slot-scope="{ item }">
                <td class="text-xs-left">
                  {{ item.id }}
                </td>
                <td class="text-xs-left min-width">
                  {{ item.title }}
                </td>
                <td class="text-xs-left">
                  <span v-if="item.resource">{{ item.resource.name }}</span>
                  <span v-else>Ресурс не установлен</span>
                </td>
                <td class="text-xs-left">
                  <span
                    class="text-warning"
                    v-if="item.is_active && item.is_active === 1"
                    >Да
                  </span>
                  <span class="text-warning" v-else>Нет </span>
                </td>
                <td class="text-xs-left">
                  <span v-if="item.created_at">{{
                    item.created_at | dateTime
                  }}</span>
                </td>
                <td class="text-xs-right min-width100">
                  <v-icon @click="openPage(item.id)">mdi-pencil</v-icon>
                </td>
              </template>
            </v-data-table>

            <v-pagination
              v-if="last_page > 1"
              v-model="page"
              class="my-4"
              :length="last_page"
            ></v-pagination>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog persistent fullscreen hide-overlay v-if="pageID" v-model="pageID">
      <Page :pageID="pageID" :closePage="closePage" />
    </v-dialog>

    <v-dialog
      width="600"
      persistent
      transition="dialog-bottom-transition"
      v-model="PageAddModal"
    >
      <v-card>
        <v-card-text>
          <div class="body-2 mb-2">Название страницы</div>
          <v-text-field
            v-model="Page_title"
            label="Введите заголовок"
            hide-details
          >
          </v-text-field>
          <br />
          <br />
        </v-card-text>
        <v-divider> </v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn color="success" text @click="addPage"
            >Добавить страницу
          </v-btn>
          <v-btn color="primary" text @click="PageAddModal = false"
            >Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../components/helper/Loader";

import { mapMutations, mapState } from "vuex";
import Page from "../components/core/Pages/Page";

export default {
  data: () => ({
    Page_title: "",
    PageAddModal: false,
    page: 1,
    searcher: null,
    loadingSearch: true,
    loading: true,
    last_page: 0,
    search: "",
    headers: [
      {
        sortable: false,
        text: "Номер страница",
        value: "id",
      },
      {
        sortable: false,
        text: "Название",
        value: "dealer.title",
      },
      {
        sortable: false,
        text: "Ресурс",
        value: "dealer.phone_number",
      },
      {
        sortable: false,
        text: "Активен",
        value: "total",
      },
      {
        sortable: false,
        text: "Дата создания",
        value: "created_at",
      },
      {
        sortable: false,
        text: "",
        value: "",
        align: "right",
      },
    ],
    PagesList: [],
    pageID: null,
  }),
  components: { Page, Loader },
  methods: {
    ...mapMutations(["SET_USER", "SET_BADGE_ORDERS"]),
    setOrders(val) {
      if (val) {
        this.getPages();
      }
    },
    getPages(noLoading) {
      if (!noLoading) this.loading = true;

      axios
        .get("admin/pages/list", {
          params: {
            per_page: 15,
            page: this.page,
            search: this.search,
          },
        })
        .then((response) => {
          this.PagesList = response.data.data;
          this.last_page = response.data.last_page;
        })
        .catch((error) => {})
        .finally(() => {
          this.loadingSearch = false;
          this.loading = false;
        });
    },
    openPage(pageID) {
      this.pageID = pageID;
    },

    closePage(update) {
      if (update) {
        this.getPages(false);
      }
      this.pageID = null;
    },

    addPage() {
      if (this.Page_title) {
        axios
          .post("admin/pages/set", {
            title: this.Page_title,
          })
          .then((response) => {
            if (response.data) {
              this.getPages(true);
              this.openPage(response.data.id);
              this.Page_title = "";
            }
            this.$toast.success({
              title: "Успешно добавно",
              message: "Добавлена новая страница.",
            });
          })
          .catch((error) => {
            let data = error.response.data;
            if (data.errors) {
              let k = 0;
              Object.keys(data.errors).forEach((item) => {
                let err = data.errors[item];
                k++;
                for (let i = 0; i < err.length; i++) {
                  setTimeout(() => {
                    this.$toast.error({
                      title: "Ошибка",
                      message: err[i],
                    });
                  }, 100 * k);
                }
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.PageAddModal = false;
          });
      } else {
        this.$toast.error({
          title: "Заголовок",
          message: "Введите заголовок",
        });
      }
    },
  },

  watch: {
    search() {
      this.loadingSearch = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.page = 1;
        this.getPages(true);
      }, 1000);
    },
    page() {
      setTimeout(() => {
        this.getPages();
      }, 300);
    },
    language(val) {
      if (val) {
        this.getPages();
      }
    },
  },
  mounted() {
    this.getPages();
  },
  computed: {
    ...mapState(["language"]),
  },
};
</script>
